import { createContext } from 'react';
import RootStore from './RootStore';

const store = RootStore.create({});

export const StoreContext = createContext(store);
export const rootStore = store;

export default store;
